import { render, staticRenderFns } from "./EditView.vue?vue&type=template&id=7ffe424a"
import script from "@/views/modules/InstitutionalDocs/js/EditView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/InstitutionalDocs/js/EditView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports